var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-space-between",attrs:{"id":"auth_header"}},[_c('div',[_c('img',{staticClass:"pt-0 mt-0 pl-0 ml-0",attrs:{"src":_vm.hcms_logo,"alt":"HCMS","width":"230px"}})]),_c('ChangeLanguage',{attrs:{"extra_padding_class":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }